// ─────────────────────────────────────────────
// Scroll lên đầu trang
// ─────────────────────────────────────────────
function scrollToTop() {
  window.scrollTo({ top: 0, behavior: "smooth" });
}

// ─────────────────────────────────────────────
// Inject block quảng cáo tài khoản PRO vào trang
// Được gọi sau khi submit form đăng ký thành công
// ─────────────────────────────────────────────
function handleProRegistrationBlock() {
  const isLoginPage = window.location.pathname.includes("/account/login");
  const registerBtnLabel = isLoginPage ? "JE M'INSCRIS" : "Je m'inscris";

  const proBlockHTML = `
    <div>
      <h2 style="font-size: 27px;">
<!--
  CERNUNOS® — INSCRIPTION COMPTE PROFESSIONNEL
  Version mobile-first et responsive.
  Compatible Shopify / Liquid personnalisé.

  Cette page suppose que le formulaire est placé dans la section
  ayant l'identifiant : pro-form
-->
<style>
  /* =========================================================
     BASE — MOBILE FIRST
     ========================================================= */

  .cernunos-pro-signup,
  .cernunos-pro-signup *,
  .cernunos-pro-signup *::before,
  .cernunos-pro-signup *::after {
    box-sizing: border-box;
  }

  .cernunos-pro-signup {
    --cp-green-950: #123322;
    --cp-green-900: #183d2a;
    --cp-green-800: #215338;
    --cp-green-700: #2c6b47;
    --cp-green-100: #e8f2eb;
    --cp-green-050: #f5faf6;
    --cp-gold: #a97a32;
    --cp-warm: #fcf8f1;
    --cp-ink: #1f2933;
    --cp-muted: #5f6b66;
    --cp-line: #dce6df;
    --cp-white: #ffffff;
    --cp-shadow: 0 14px 38px rgba(24, 61, 42, 0.09);

    width: 100%;
    max-width: 1120px;
    margin: 0 auto;
    padding: 8px 14px 90px;
    color: var(--cp-ink);
    font: inherit;
    line-height: 1.65;
  }

  .cernunos-pro-signup img,
  .cernunos-pro-signup svg {
    max-width: 100%;
  }

  .cernunos-pro-signup a {
    color: var(--cp-green-800);
    text-underline-offset: 3px;
  }

  .cernunos-pro-signup h2,
  .cernunos-pro-signup h3,
  .cernunos-pro-signup p {
    overflow-wrap: anywhere;
  }

  .cernunos-pro-signup h2,
  .cernunos-pro-signup h3 {
    color: var(--cp-green-950);
    line-height: 1.2;
    letter-spacing: -0.025em;
  }

  .cernunos-pro-signup h2 {
    margin: 0 0 14px;
    font-size: clamp(1.7rem, 7vw, 2.3rem);
  }

  .cernunos-pro-signup h3 {
    margin: 0 0 8px;
    font-size: 1.08rem;
  }

  .cernunos-pro-signup p {
    margin: 0 0 14px;
  }

  .cp-section {
    margin-top: 22px;
  }

  /*
    Laisse de l'espace au-dessus du formulaire lorsque l'on clique
    sur un bouton d'ancrage, notamment avec un header Shopify fixe.
  */

  #pro-form {
    scroll-margin-top: 100px;
  }

  .cp-card {
    border: 1px solid var(--cp-line);
    border-radius: 17px;
    background: var(--cp-white);
    box-shadow: var(--cp-shadow);
  }

  .cp-panel {
    padding: 21px 17px;
  }

  .cp-eyebrow {
    display: block;
    margin: 0 0 9px;
    color: var(--cp-gold);
    font-size: 0.74rem;
    font-weight: 850;
    letter-spacing: 0.07em;
    line-height: 1.3;
    text-transform: uppercase;
  }

  .cp-lead {
    max-width: 820px;
    color: #34433c;
    font-size: clamp(1rem, 4.5vw, 1.18rem);
    line-height: 1.62;
  }

  .cp-small {
    color: var(--cp-muted);
    font-size: 0.84rem;
    line-height: 1.5;
  }

  /* =========================================================
     GRILLES — 1 COLONNE PAR DÉFAUT
     ========================================================= */

  .cp-grid-2,
  .cp-grid-3,
  .cp-grid-4 {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    gap: 12px;
  }

  /* =========================================================
     BOUTONS
     ========================================================= */

  .cp-btn-row {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 20px;
  }

  .cp-btn {
    display: inline-flex;
    width: 100%;
    min-height: 50px;
    align-items: center;
    justify-content: center;
    padding: 13px 18px;
    border: 2px solid transparent;
    border-radius: 12px;
    font: inherit;
    font-weight: 850;
    line-height: 1.25;
    text-align: center;
    text-decoration: none !important;
    cursor: pointer;
    transition:
      transform 0.18s ease,
      background-color 0.18s ease,
      border-color 0.18s ease,
      box-shadow 0.18s ease;
  }

  .cp-btn:hover {
    transform: translateY(-1px);
  }

  .cp-btn:focus-visible {
    outline: 3px solid rgba(169, 122, 50, 0.4);
    outline-offset: 3px;
  }

  .cernunos-pro-signup a.cp-btn--primary,
  .cernunos-pro-signup a.cp-btn--primary:link,
  .cernunos-pro-signup a.cp-btn--primary:visited {
    border-color: var(--cp-green-800);
    background: var(--cp-green-800);
    color: var(--cp-white) !important;
  }

  .cernunos-pro-signup a.cp-btn--primary:hover,
  .cernunos-pro-signup a.cp-btn--primary:focus {
    border-color: var(--cp-green-950);
    background: var(--cp-green-950);
    color: var(--cp-white) !important;
    box-shadow: 0 10px 24px rgba(18, 51, 34, 0.16);
  }

  .cernunos-pro-signup a.cp-btn--secondary,
  .cernunos-pro-signup a.cp-btn--secondary:link,
  .cernunos-pro-signup a.cp-btn--secondary:visited {
    border-color: var(--cp-green-700);
    background: var(--cp-white);
    color: var(--cp-green-800) !important;
  }

  .cernunos-pro-signup a.cp-btn--secondary:hover,
  .cernunos-pro-signup a.cp-btn--secondary:focus {
    background: var(--cp-green-050);
    color: var(--cp-green-950) !important;
  }

  /* =========================================================
     HERO
     ========================================================= */

  .cp-hero {
    position: relative;
    overflow: hidden;
    padding: 27px 18px;
    border: 1px solid var(--cp-line);
    border-radius: 21px;
    background:
      radial-gradient(
        circle at 100% 0%,
        rgba(169, 122, 50, 0.15),
        transparent 34%
      ),
      linear-gradient(
        145deg,
        #ffffff 0%,
        var(--cp-green-050) 100%
      );
    box-shadow: var(--cp-shadow);
  }

  .cp-hero::after {
    position: absolute;
    right: -105px;
    bottom: -115px;
    width: 250px;
    height: 250px;
    border: 34px solid rgba(44, 107, 71, 0.06);
    border-radius: 50%;
    content: "";
    pointer-events: none;
  }

  .cp-hero__content {
    position: relative;
    z-index: 1;
    max-width: 870px;
  }

  .cp-hero__statement {
    max-width: 790px;
    margin: 0 0 16px;
    color: var(--cp-green-950);
    font-size: clamp(1.5rem, 7vw, 2.5rem);
    font-weight: 780;
    line-height: 1.16;
    letter-spacing: -0.035em;
  }

  .cp-chips {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 18px;
  }

  .cp-chip {
    padding: 7px 10px;
    border: 1px solid #d4e2d8;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.92);
    color: var(--cp-green-950);
    font-size: 0.79rem;
    font-weight: 750;
    line-height: 1.35;
  }

  /* =========================================================
     PREUVES
     ========================================================= */

  .cp-proof {
    padding: 18px 16px;
    text-align: center;
  }

  .cp-proof strong {
    display: block;
    margin-bottom: 5px;
    color: var(--cp-green-950);
    font-size: clamp(1.15rem, 5vw, 1.55rem);
    line-height: 1.12;
  }

  .cp-proof span {
    color: var(--cp-muted);
    font-size: 0.86rem;
    line-height: 1.42;
  }

  /* =========================================================
     AVANTAGES
     ========================================================= */

  .cp-benefit {
    padding: 18px;
  }

  .cp-label {
    display: block;
    margin-bottom: 7px;
    color: var(--cp-gold);
    font-size: 0.72rem;
    font-weight: 850;
    letter-spacing: 0.065em;
    text-transform: uppercase;
  }

  .cp-note {
    margin-top: 18px;
    padding: 18px;
    border-left: 4px solid var(--cp-gold);
    border-radius: 0 14px 14px 0;
    background: var(--cp-warm);
  }

  .cp-note p:last-child {
    margin-bottom: 0;
  }

  /* =========================================================
     ÉTAPES
     ========================================================= */

  .cp-step {
    position: relative;
    min-height: 175px;
    padding: 55px 18px 18px;
  }

  .cp-step__number {
    position: absolute;
    top: 14px;
    left: 18px;
    color: var(--cp-green-100);
    font-size: 2.4rem;
    font-weight: 950;
    line-height: 1;
  }

  /* =========================================================
     FORMULAIRE
     ========================================================= */

  .cp-form {
    overflow: hidden;
  }

  .cp-form__header {
    padding: 24px 17px 16px;
    text-align: center;
  }

  .cp-form__header p {
    max-width: 760px;
    margin-right: auto;
    margin-left: auto;
  }

  /*
    Place ton formulaire Shopify, Tally, BSS ou autre directement
    dans cette zone ou immédiatement sous cette section.
  */

  .cp-form__slot {
    margin: 0 17px 22px;
    overflow: hidden;
    border: 1px solid var(--cp-line);
    border-radius: 14px;
    background: var(--cp-green-050);
  }

  .cp-form__slot iframe {
    display: block;
    width: 100%;
    min-height: 720px;
    border: 0;
    background: transparent;
  }

  /*
    Cette classe peut être retirée lorsque le véritable formulaire
    est inséré dans .cp-form__slot.
  */

  .cp-form__placeholder {
    padding: 22px 18px;
    color: var(--cp-muted);
    font-size: 0.88rem;
    line-height: 1.55;
    text-align: center;
  }

  /* =========================================================
     FAQ
     ========================================================= */

  .cp-faq {
    display: grid;
    gap: 9px;
    margin-top: 14px;
  }

  .cp-faq details {
    overflow: hidden;
    border: 1px solid var(--cp-line);
    border-radius: 13px;
    background: var(--cp-white);
  }

  .cp-faq summary {
    position: relative;
    padding: 15px 43px 15px 15px;
    color: var(--cp-green-950);
    font-weight: 800;
    line-height: 1.4;
    cursor: pointer;
    list-style: none;
  }

  .cp-faq summary::-webkit-details-marker {
    display: none;
  }

  .cp-faq summary::after {
    position: absolute;
    top: 50%;
    right: 16px;
    transform: translateY(-50%);
    color: var(--cp-green-700);
    font-size: 1.3rem;
    content: "+";
  }

  .cp-faq details[open] summary::after {
    content: "−";
  }

  .cp-faq__answer {
    padding: 0 15px 15px;
    color: var(--cp-muted);
  }

  .cp-faq__answer p:last-child {
    margin-bottom: 0;
  }

  /* =========================================================
     CTA FINAL
     ========================================================= */

  .cp-final {
    padding: 28px 18px;
    overflow: hidden;
    background:
      radial-gradient(
        circle at 100% 0%,
        rgba(255, 255, 255, 0.08),
        transparent 35%
      ),
      var(--cp-green-950);
    color: var(--cp-white);
    text-align: center;
  }

  .cp-final h2,
  .cp-final p {
    color: var(--cp-white);
  }

  .cp-final p {
    max-width: 700px;
    margin-right: auto;
    margin-left: auto;
    color: #dbe8df;
  }

  .cp-final .cp-btn-row {
    align-items: center;
  }

  .cernunos-pro-signup .cp-final a.cp-btn--primary,
  .cernunos-pro-signup .cp-final a.cp-btn--primary:link,
  .cernunos-pro-signup .cp-final a.cp-btn--primary:visited {
    border-color: var(--cp-white) !important;
    background: var(--cp-white) !important;
    color: var(--cp-green-950) !important;
  }

  .cernunos-pro-signup .cp-final a.cp-btn--primary:hover,
  .cernunos-pro-signup .cp-final a.cp-btn--primary:focus {
    border-color: var(--cp-green-100) !important;
    background: var(--cp-green-100) !important;
    color: var(--cp-green-950) !important;
  }

  /* =========================================================
     CTA FIXE MOBILE
     ========================================================= */

  .cp-mobile-cta {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 60;
    padding:
      10px
      14px
      calc(10px + env(safe-area-inset-bottom));
    border-top: 1px solid var(--cp-line);
    background: rgba(255, 255, 255, 0.97);
    box-shadow: 0 -8px 24px rgba(24, 61, 42, 0.1);
    backdrop-filter: blur(8px);
    transition:
      opacity 0.2s ease,
      transform 0.2s ease,
      visibility 0.2s ease;
  }

  .cp-mobile-cta .cp-btn {
    width: 100%;
    min-height: 48px;
  }

  /*
    Le CTA fixe disparaît lorsque le formulaire est visible,
    afin de ne pas masquer les champs ou le bouton d'envoi.
  */

  .cp-mobile-cta.is-hidden {
    opacity: 0;
    visibility: hidden;
    transform: translateY(110%);
    pointer-events: none;
  }

  /* =========================================================
     TABLETTES
     ========================================================= */

  @media (min-width: 640px) {
    .cernunos-pro-signup {
      padding-right: 22px;
      padding-left: 22px;
    }

    .cp-panel {
      padding: 28px;
    }

    .cp-hero {
      padding: 34px 30px;
    }

    .cp-btn-row {
      flex-direction: row;
      align-items: center;
    }

    .cp-btn {
      width: auto;
    }

    .cp-grid-2,
    .cp-grid-3,
    .cp-grid-4 {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .cp-form__header {
      padding: 30px 30px 16px;
    }

    .cp-form__slot {
      margin-right: 30px;
      margin-bottom: 30px;
      margin-left: 30px;
    }

    .cp-final {
      padding: 36px 30px;
    }

    .cp-final .cp-btn-row {
      justify-content: center;
    }
  }

  /* =========================================================
     ORDINATEURS
     ========================================================= */

  @media (min-width: 900px) {
    .cernunos-pro-signup {
      padding-bottom: 50px;
    }

    .cp-hero {
      padding: 42px;
    }

    .cp-grid-3 {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }

    .cp-grid-4 {
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }

    .cp-mobile-cta {
      display: none;
    }
  }

  /* =========================================================
     GRANDS ÉCRANS
     ========================================================= */

  @media (min-width: 1180px) {
    .cernunos-pro-signup {
      padding-right: 0;
      padding-left: 0;
    }
  }

  /* =========================================================
     ACCESSIBILITÉ
     ========================================================= */

  @media (prefers-reduced-motion: reduce) {
    .cp-btn,
    .cp-mobile-cta {
      transition: none;
    }
  }
</style>
<!-- split -->

<style>
  /* =========================================================
     CERNUNOS® — COLONNE DROITE COMPTE PROFESSIONNEL
     Version premium, mobile-first et orientée conversion
     ========================================================= */

  .cernunos-pro-conversion,
  .cernunos-pro-conversion *,
  .cernunos-pro-conversion *::before,
  .cernunos-pro-conversion *::after {
    box-sizing: border-box;
  }

  .cernunos-pro-conversion {
    --pro-green-950: #123322;
    --pro-green-900: #183d2a;
    --pro-green-800: #215338;
    --pro-green-700: #2c6b47;
    --pro-green-100: #e8f2eb;
    --pro-green-050: #f5faf6;
    --pro-gold: #a97a32;
    --pro-cream: #fcf8f1;
    --pro-text: #1f2933;
    --pro-muted: #5f6b66;
    --pro-border: #dce6df;
    --pro-white: #ffffff;
    --pro-shadow: 0 16px 42px rgba(24, 61, 42, 0.1);

    width: 100%;
    margin: 0;
    color: var(--pro-text);
    font: inherit;
    line-height: 1.62;
  }

  .cernunos-pro-conversion h2,
  .cernunos-pro-conversion h3,
  .cernunos-pro-conversion p {
    overflow-wrap: anywhere;
  }

  .cernunos-pro-conversion h2,
  .cernunos-pro-conversion h3 {
    color: var(--pro-green-950);
    line-height: 1.18;
    letter-spacing: -0.025em;
  }

  .cernunos-pro-conversion h2 {
    margin: 0 0 14px;
    font-size: clamp(1.65rem, 6vw, 2.25rem);
  }

  .cernunos-pro-conversion h3 {
    margin: 0 0 5px;
    font-size: 1rem;
  }

  .cernunos-pro-conversion p {
    margin: 0 0 14px;
  }

  /* CARTE PRINCIPALE */

  .pro-conversion-card {
    position: relative;
    overflow: hidden;
    padding: 26px 18px;
    border: 1px solid var(--pro-border);
    border-radius: 22px;
    background:
      radial-gradient(
        circle at 100% 0%,
        rgba(169, 122, 50, 0.15),
        transparent 32%
      ),
      linear-gradient(
        145deg,
        var(--pro-white) 0%,
        var(--pro-green-050) 100%
      );
    box-shadow: var(--pro-shadow);
  }

  .pro-conversion-card::after {
    position: absolute;
    right: -115px;
    bottom: -125px;
    width: 260px;
    height: 260px;
    border: 35px solid rgba(44, 107, 71, 0.05);
    border-radius: 50%;
    content: "";
    pointer-events: none;
  }

  .pro-conversion-content {
    position: relative;
    z-index: 1;
  }

  .pro-eyebrow {
    display: block;
    margin-bottom: 9px;
    color: var(--pro-gold);
    font-size: 0.73rem;
    font-weight: 850;
    letter-spacing: 0.075em;
    line-height: 1.3;
    text-transform: uppercase;
  }

  .pro-lead {
    color: #34433c;
    font-size: 1rem;
    line-height: 1.65;
  }

  /* INFORMATIONS ESSENTIELLES */

  .pro-chips {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 18px;
  }

  .pro-chip {
    padding: 7px 10px;
    border: 1px solid #d4e2d8;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.94);
    color: var(--pro-green-950);
    font-size: 0.77rem;
    font-weight: 750;
    line-height: 1.35;
  }

  /* AVANTAGES */

  .pro-benefits {
    display: grid;
    gap: 10px;
    margin-top: 20px;
  }

  .pro-benefit {
    position: relative;
    padding: 15px 15px 15px 49px;
    border: 1px solid var(--pro-border);
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.94);
  }

  .pro-benefit::before {
    position: absolute;
    top: 15px;
    left: 15px;
    display: flex;
    width: 24px;
    height: 24px;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: var(--pro-green-100);
    color: var(--pro-green-800);
    font-size: 0.8rem;
    font-weight: 950;
    content: "✓";
  }

  .pro-benefit p {
    margin: 0;
    color: var(--pro-muted);
    font-size: 0.87rem;
    line-height: 1.5;
  }

  /* PREUVES */

  .pro-proof-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 1px;
    margin-top: 20px;
    overflow: hidden;
    border: 1px solid var(--pro-border);
    border-radius: 14px;
    background: var(--pro-border);
  }

  .pro-proof {
    min-width: 0;
    padding: 14px 7px;
    background: var(--pro-white);
    text-align: center;
  }

  .pro-proof strong {
    display: block;
    margin-bottom: 4px;
    color: var(--pro-green-950);
    font-size: 0.91rem;
    line-height: 1.25;
  }

  .pro-proof span {
    display: block;
    color: var(--pro-muted);
    font-size: 0.68rem;
    line-height: 1.35;
  }

  /* RÉASSURANCE */

  .pro-reassurance {
    margin-top: 18px;
    padding: 16px;
    border-left: 4px solid var(--pro-gold);
    border-radius: 0 13px 13px 0;
    background: var(--pro-cream);
  }

  .pro-reassurance strong {
    display: block;
    margin-bottom: 5px;
    color: var(--pro-green-950);
  }

  .pro-reassurance p {
    margin: 0;
    color: #4f5d56;
    font-size: 0.87rem;
    line-height: 1.55;
  }

  /* BOUTONS */

  .pro-actions {
    display: grid;
    gap: 10px;
    margin-top: 20px;
  }

  .pro-button {
    display: inline-flex;
    width: 100%;
    min-height: 50px;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 13px 16px;
    border: 2px solid transparent;
    border-radius: 12px;
    font: inherit;
    font-size: 0.9rem;
    font-weight: 850;
    line-height: 1.25;
    text-align: center;
    text-decoration: none !important;
    cursor: pointer;
    transition:
      transform 0.18s ease,
      background-color 0.18s ease,
      border-color 0.18s ease,
      box-shadow 0.18s ease;
  }

  .pro-button:hover {
    transform: translateY(-1px);
  }

  .pro-button:focus-visible {
    outline: 3px solid rgba(169, 122, 50, 0.4);
    outline-offset: 3px;
  }

  .cernunos-pro-conversion .pro-button-primary,
  .cernunos-pro-conversion .pro-button-primary:link,
  .cernunos-pro-conversion .pro-button-primary:visited {
    border-color: var(--pro-green-800);
    background: var(--pro-green-800);
    color: var(--pro-white) !important;
  }

  .cernunos-pro-conversion .pro-button-primary:hover,
  .cernunos-pro-conversion .pro-button-primary:focus {
    border-color: var(--pro-green-950);
    background: var(--pro-green-950);
    color: var(--pro-white) !important;
    box-shadow: 0 10px 24px rgba(18, 51, 34, 0.17);
  }

  .cernunos-pro-conversion .pro-button-secondary,
  .cernunos-pro-conversion .pro-button-secondary:link,
  .cernunos-pro-conversion .pro-button-secondary:visited {
    border-color: var(--pro-green-700);
    background: var(--pro-white);
    color: var(--pro-green-800) !important;
  }

  .cernunos-pro-conversion .pro-button-secondary:hover,
  .cernunos-pro-conversion .pro-button-secondary:focus {
    background: var(--pro-green-050);
    color: var(--pro-green-950) !important;
  }

  .pro-button svg {
    flex: 0 0 auto;
    width: 17px;
    height: 17px;
  }

  .pro-validation-note {
    margin: 13px 0 0;
    color: var(--pro-muted);
    font-size: 0.78rem;
    line-height: 1.5;
    text-align: center;
  }

  /* MOBILE */

  @media (max-width: 479px) {
    .pro-proof-grid {
      grid-template-columns: 1fr;
    }

    .pro-proof {
      padding: 12px;
    }

    .pro-proof span {
      font-size: 0.76rem;
    }
  }

  /* TABLETTE */

  @media (min-width: 640px) {
    .pro-conversion-card {
      padding: 32px 27px;
    }

    .pro-benefits {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .pro-benefit:last-child {
      grid-column: 1 / -1;
    }
  }

  /* ORDINATEUR */

  @media (min-width: 900px) {
    .cernunos-pro-conversion {
      position: sticky;
      top: 105px;
    }

    .pro-conversion-card {
      padding: 28px 24px;
    }

    .pro-benefits {
      grid-template-columns: 1fr;
    }

    .pro-benefit:last-child {
      grid-column: auto;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .pro-button {
      transition: none;
    }
  }
</style>

<section
  class="cernunos-pro-conversion"
  aria-label="Avantages du compte professionnel Cernunos"
>
  <div class="pro-conversion-card">
    <div class="pro-conversion-content">

      <span class="pro-eyebrow">
        Compte professionnel Cernunos®
      </span>

      <h2>
        Développez votre offre avec plus de 250 références naturelles
      </h2>

      <p class="pro-lead">
        Vous êtes gérant d’une animalerie, éducateur canin, toiletteur,
        éleveur, vétérinaire, pet-sitter, revendeur en ligne ou porteur de projet&nbsp;?
        Ouvrez gratuitement votre compte professionnel et accédez à des
        conditions adaptées à votre activité.
      </p>

      <div
        class="pro-chips"
        aria-label="Conditions principales du compte professionnel"
      >
        <span class="pro-chip">
          Minimum&nbsp;: 100€ HT
        </span>

        <span class="pro-chip">
          Tarifs dégressifs
        </span>

        <span class="pro-chip">
          Compte gratuit
        </span>

        <span class="pro-chip">
          Expédition depuis la France
        </span>
      </div>

      <div class="pro-benefits">

        <article class="pro-benefit">
          <h3>
            Des tarifs réservés aux professionnels
          </h3>

          <p>
            Accédez à des prix dédiés et à des conditions dégressives
            selon les références et les quantités commandées.
          </p>
        </article>

        <article class="pro-benefit">
          <h3>
            Une sélection spécialisée
          </h3>

          <p>
            Friandises naturelles, produits de mastication, viandes,
            poissons séchés et références différenciantes.
          </p>
        </article>

        <article class="pro-benefit">
          <h3>
            Un accompagnement personnalisé
          </h3>

          <p>
            Notre équipe peut vous conseiller pour construire une première
            sélection adaptée à votre clientèle, votre budget et votre
            espace de vente.
          </p>
        </article>

      </div>

      <div
        class="pro-proof-grid"
        aria-label="Éléments de confiance Cernunos"
      >
        <div class="pro-proof">
          <strong>Depuis 2015</strong>
          <span>Expertise spécialisée</span>
        </div>

        <div class="pro-proof">
          <strong>+250 références</strong>
          <span>Une offre différenciante</span>
        </div>

        <div class="pro-proof">
          <strong>Centravet</strong>
          <span>Réseau vétérinaire</span>
        </div>
      </div>

      <div class="pro-reassurance">
        <strong>
          Une demande simple et sans engagement
        </strong>

        <p>
          Présentez brièvement votre activité dans le formulaire. Notre
          équipe étudiera votre demande et vous contactera uniquement si
          des informations complémentaires sont nécessaires.
        </p>
      </div>

      <div class="pro-actions">

        <a
          href="#"
          class="pro-button pro-button-primary"
          data-scroll-page-top
        >
          Remplir le formulaire

          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            aria-hidden="true"
          >
            <path d="M12 19V5"></path>
            <path d="m6 11 6-6 6 6"></path>
          </svg>
        </a>

        <a
          href="/pages/grossiste-friandise-naturelle-chien-boostez-ventes-cernunos"
          class="pro-button pro-button-secondary"
        >
          Découvrir l’offre grossiste Cernunos
        </a>

      </div>

      <p class="pro-validation-note">
        L’accès aux tarifs professionnels est activé après validation
        de votre activité.
      </p>

    </div>
  </div>
</section>

<script>
  (function () {
    var buttons = document.querySelectorAll(
      ".cernunos-pro-conversion [data-scroll-page-top]"
    );

    if (!buttons.length) {
      return;
    }

    buttons.forEach(function (button) {
      button.addEventListener("click", function (event) {
        event.preventDefault();

        var reducedMotion = window.matchMedia(
          "(prefers-reduced-motion: reduce)"
        ).matches;

        window.scrollTo({
          top: 0,
          left: 0,
          behavior: reducedMotion ? "auto" : "smooth"
        });
      });
    });
  })();
</script>
  `;

  document.querySelector(".one-whole").insertAdjacentHTML("beforeend", proBlockHTML);
}

// ─────────────────────────────────────────────
// Fix checkout button bị disable trên trang Quick Order (Customer Portal)
// Poll mỗi 100ms đến khi button xuất hiện, timeout sau 10s
// ─────────────────────────────────────────────
(function initQuickOrderCheckoutFix() {
  // Fallback: luôn enable #checkout sau 6s phòng trường hợp event không fire
  setTimeout(() => {
    $("#checkout").css({ pointerEvents: "auto", opacity: "1" });
  }, 6000);

  const isQuickOrderPage = window.location.pathname === "/apps/customer-portal/quick-order";
  if (!isQuickOrderPage) return;

  const pollInterval = setInterval(() => {
    const quickOrderCheckoutBtn = document.querySelector("#bss-bcp-qo-checkout-btn");
    if (!quickOrderCheckoutBtn) return;

    // Bỏ trạng thái disabled của Polaris Button
    quickOrderCheckoutBtn.setAttribute("aria-disabled", "false");
    quickOrderCheckoutBtn.classList.remove("Polaris-Button--disabled");

    // Redirect về /cart thay vì xử lý checkout mặc định
    quickOrderCheckoutBtn.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      window.location.href = "/cart";
    }, true);

    clearInterval(pollInterval);
  }, 100);

  // Dừng poll sau 10s nếu button không xuất hiện
  setTimeout(() => {
    clearInterval(pollInterval);
  }, 10000);
})();

// ─────────────────────────────────────────────
// Inject CSS fix layout VAT price trên Customer Portal
// ─────────────────────────────────────────────
document.addEventListener("DOMContentLoaded", function () {
  const isCustomerPortalPage = window.location.pathname.includes("apps/customer-portal");
  if (!isCustomerPortalPage) return;

  const styleEl = document.createElement("style");
  styleEl.innerHTML = `
    .bss-b2b-qo-vat-price-no-vat,
    .bss-bcp-qo-vat-price-has-vat,
    .bss-bcp-qo-product-list-table .price-field > p {
      display: flex;
    }
    .bss-bcp-qo-product-list-table .price-field > p {
      gap: 4px;
    }
    .bss-bcp-qo-cart-table .line-item-total-price > p {
      display: flex;
      flex-direction: column;
    }
  `;
  document.head.appendChild(styleEl);
});

// ─────────────────────────────────────────────
// Trigger load B2B pricing rule trên product page sau 2s
// ─────────────────────────────────────────────
setTimeout(() => {
  const isProductPage = window.location.pathname.includes("/product");
  if (isProductPage && BSS_B2B && typeof BSS_B2B.ef?.getAppliedRuleOnProductPage === "function") {
    BSS_B2B.ef.getAppliedRuleOnProductPage(false);
  }
}, 2000);

// ─────────────────────────────────────────────
// Trigger scroll event để kích hoạt lazy load form đăng ký PRO
// Poll đến khi form xuất hiện, timeout sau 4s
// ─────────────────────────────────────────────
document.addEventListener("DOMContentLoaded", function () {
  const registrationPagePaths = [
    "/pages/registration-form",
    "/pages/inscription-compte-pro-cernunos",
  ];
  const isRegistrationPage = registrationPagePaths.includes(window.location.pathname);
  if (!isRegistrationPage) return;

  const pollForRegistrationForm = setInterval(() => {
    const registrationForm = document.querySelector("#bss-b2b-registration-form");
    if (!registrationForm) return;

    window.dispatchEvent(new Event("scroll"));
    clearInterval(pollForRegistrationForm);
  });

  setTimeout(() => {
    clearInterval(pollForRegistrationForm);
  }, 4000);
});

// ─────────────────────────────────────────────
// Sau khi form đăng ký submit thành công → inject block PRO
// ─────────────────────────────────────────────
document.addEventListener("BSS_get_form_success", () => {
  const registrationPagePaths = [
    "/pages/registration-form",
    "/pages/inscription-compte-pro-cernunos",
  ];
  const isRegistrationPage = registrationPagePaths.includes(window.location.pathname);
  console.log({isRegistrationPage})
  if (isRegistrationPage) {
    handleProRegistrationBlock();
  }
});